import mikrotik from './brands/mikrotik.svg';
import opnsense from './brands/opnsense.svg';
import cisco from './brands/cisco.svg';
import fortinet from './brands/fortinet.svg';
import juniper from './brands/junipernetworks-light.svg';
import paloalto from './brands/palo-alto-networks-dark.svg';
import sophos from './brands/sophos.svg';

const brandIcons: Record<string, React.FC<{ size?: number }>> = {
    mikrotik: (props) => <img src={mikrotik} title="Mikrotik" width={props.size} height={props.size} />,
    opnsense: (props) => <img src={opnsense} title="OPNsense" width={props.size} height={props.size} />,
    cisco: (props) => <img src={cisco} title="Cisco" width={props.size} height={props.size} />,
    fortinet: (props) => <img src={fortinet} title="Fortinet" width={props.size} height={props.size} />,
    juniper: (props) => <img src={juniper} title="Juniper" width={props.size} height={props.size} />,
    paloalto: (props) => <img src={paloalto} title="Palo Alto Networks" width={props.size} height={props.size} />,
    sophos: (props) => <img src={sophos} title="Sophos" width={props.size} height={props.size} />,
};

export const BrandIcon = ({ brand, size = 24 }: { brand: string; size?: number }) => {
    const IconComponent = brandIcons[brand];

    if (!IconComponent) {
        return null;
    }

    return <IconComponent size={size} />;
};